import PropTypes from "prop-types";
import React from "react";

/**
 * Development error fallback component that displays detailed error information
 * including error message and component stack trace.
 * Only used in development mode.
 */
const DevErrorFallback = ({ error, errorInfo }) => {
  return (
    <div
      data-test="dev-error-fallback"
      style={{
        position: "fixed",
        padding: "20px",
        fontFamily: "monospace",
        color: "#d4d4d4",
        minHeight: "100vh",
      }}>
      <div
        style={{
          backgroundColor: "#4a4a4a",
          color: "white",
          padding: "15px",
          marginBottom: "20px",
          borderRadius: "4px",
        }}>
        <h1 style={{ margin: "0 0 10px 0", fontSize: "24px" }}>
          ⚠️ Application Error
        </h1>
        <p style={{ margin: 0, fontSize: "14px" }}>
          The application encountered an error. See details below:
        </p>
      </div>

      <div
        style={{
          padding: "15px",
          borderRadius: "4px",
          marginBottom: "20px",
        }}>
        <h2
          style={{
            color: "black",
            margin: "0 0 10px 0",
            fontSize: "18px",
          }}>
          Error Message:
        </h2>
        <pre
          style={{
            margin: 0,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            color: "black",
          }}>
          {error?.toString()}
        </pre>
      </div>

      {errorInfo?.componentStack && (
        <div
          style={{
            padding: "15px",
            borderRadius: "4px",
          }}>
          <h2
            style={{
              color: "black",
              margin: "0 0 10px 0",
              fontSize: "18px",
            }}>
            Component Stack:
          </h2>
          <pre
            style={{
              margin: 0,
              fontSize: "12px",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              color: "black",
            }}>
            {errorInfo.componentStack}
          </pre>
        </div>
      )}

      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#4fc3f7",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "14px",
        }}>
        Reload Application
      </button>
    </div>
  );
};

DevErrorFallback.propTypes = {
  error: PropTypes.object,
  errorInfo: PropTypes.object,
};

export default DevErrorFallback;
